// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media print {\n  .sequence {\n    padding-left: 0.1em;\n  }\n}\n.sequence h2 {\n  font-size: 1.25em;\n  margin-top: 0;\n  margin-bottom: 0.25em;\n}\n@media print {\n  .sequence h2 {\n    color: #000;\n    font-size: 1.15em;\n    font-weight: normal;\n  }\n}\n", ""]);
// Exports
module.exports = exports;
